angular.module('mobilezuz')
    .directive('rowActionsSwipe', [function () {
        return {
            transclude: true,
            template:   '<div class="actions-swipe">' +
                            '<button class="edit" ng-click="clickOnEdit()">{{\'Edit\' | translate}}</button>' +
                            '<div class="original-element" ng-class="{\'delete-active\': isDeleteActive, \'edit-active\': isEditActive}" ' +
                            ' ng-swipe-left="onSwipe(\'left\')" ng-swipe-right="onSwipe(\'right\')" ng-transclude>' +
                            '</div>' +
                            '<button class="delete" ng-click="clickOnRemove()">{{\'Delete\' | translate}}</button>' +
                        '</div>',
            restrict: 'A',
            scope: {
                onRemove: '&?',
                onEdit: '&?'
            },
            link: function ($scope) {
                $scope.clickOnRemove = clickOnRemove;
                $scope.clickOnEdit = clickOnEdit;
                $scope.onSwipe = swipe;

                var isHasDelete = !!$scope.onRemove,
                    isHasEdit = !!$scope.onEdit;

                $scope.isDeleteActive = $scope.isEditActive = false;

                function swipe(dir) {
                    if (dir === 'right') {
                        $scope.isEditActive = isHasEdit && (!isHasDelete || !$scope.isDeleteActive);
                        $scope.isDeleteActive = false;
                    } else if (dir === 'left') {
                        $scope.isDeleteActive = isHasDelete && (!isHasEdit || !$scope.isEditActive);
                        $scope.isEditActive = false;
                    }
                }

                function clickOnRemove() {
                    $scope.onRemove && $scope.onRemove();
                }

                function clickOnEdit() {
                    $scope.onSwipe('left');
                    $scope.onEdit && $scope.onEdit();
                }
            }
        };
    }]);